import { ApiMethod } from '@wajeez-web/stores/base';
import { AppWatch, appWatchClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export const getUserDevices: ApiMethod<
  string,
  AppWatch.UserDevice[],
  any
> = async (userId, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_IdentityQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.identityQueries_userDevices_V1(userId);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getAllPolicies', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getUserMonthlySessions: ApiMethod<
  string,
  AppWatch.MonthlyUserSessionTime[],
  any
> = async (userId, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.contentQueries_monthlyUserSessionBreakdown_V1(
      userId
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getAllPolicies', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getUserDailySessions: ApiMethod<
  string,
  AppWatch.MonthlyUserSessionTime[],
  any
> = async (userId, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.contentQueries_dailyUserSessionBreakdown_V1(
      userId
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getAllPolicies', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getUserConsumedContent: ApiMethod<
  string,
  AppWatch.ConsumedContent[],
  any
> = async (userId, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.contentQueries_userConsumedContent_V1(userId);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getAllPolicies', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getUserSubscriptionHistory: ApiMethod<
  string,
  AppWatch.SubscriptionHistoryRow[],
  any
> = async (userId, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_PaymentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.paymentQueries_userSubscriptionHistory_V1(
      userId
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    console.log('getAllPolicies', error);
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
